import { v1 as uuidv1 } from 'uuid';
import fetch from '../../../../utils/fetcher';
import { videoApiUrl } from '../../../../config';


export const MAX_VIDEO_DURATION = 60; // 60 seconds
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

export const uploadVideoToExternalApi = async (file, uploadToken) => {
  if (!uploadToken) { throw new Error('Upload token is required') };
  if (!file) { throw new Error('File is required') };

  const formData = new FormData();
  formData.append('file', file);

  const url = `${videoApiUrl}?token=${uploadToken}`;
  const options = {
    method: 'POST',
    body: formData,
    headers: { Accept: 'application/json' },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data.videoId;
  } catch (error) {
    throw new Error('Failed to upload video');
  }
};

export const sendVideoUrlToOperations = async (videoId, campaignId=null) => {
  if (!videoId) { throw new Error('Video ID is required') };
  const campaign = campaignId || uuidv1().slice(0, 7);
  
  const baseUrl = `${process.env.REACT_APP_MEDIA_API_URL}/video`;
  const url = `${baseUrl}?campaign=${campaign}&videoCode=${videoId}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data.code;
  } catch (error) {
    throw new Error('Failed to send video URL to operations');
  }
};
